import axios from "axios";
import { isDevMode, timeout } from "./utils";
import { API_GET_RESPONSE_MOCKS } from "../constants/mocks";

/**
 * A helper function to wrap the API call to
 * allow efficient dev-mode mocking.
 *
 * @param {string} route The API route to use
 */
const fetchFromAPI = async (route) => {
  if (isDevMode()) {
    await timeout(1000);
    return API_GET_RESPONSE_MOCKS[route] ?? { data: "" };
  }

  const token = localStorage.getItem("token");
  const response = await axios.get(route, {
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
    },
  });
  return response;
};

export default fetchFromAPI;